import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { SelfCreditComponent } from './pages/self-credit/Credit/self-credit.component';
import { OtpDocComponent } from './pages/self-credit/otp-doc/otp-doc.component';
import { ApproveRequestComponent } from './pages/requests/approve-request/approve-request.component';
import { CancelRequestComponent } from './pages/requests/cancel-request/cancel-request.component';
import { CoDebtorComponent } from './pages/self-credit/co-debtor/co-debtor.component';
import { RequestsCreditsComponent } from './pages/requests/requests-credits/requests-credits.component';
import { userComponent } from './pages/users/createUser/user.component';
import { NativeSessionComponent } from './account/auth/native-session/native-session.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'native-session', component: NativeSessionComponent },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'user', component: userComponent },
  { path: 'self-credit/:userId', component: SelfCreditComponent },
  { path: 'self-credit', component: SelfCreditComponent },
  { path: 'request-credit', component: RequestsCreditsComponent },
  { path: 'codebtor/:id', component: CoDebtorComponent },
  { path: 'otp-doc/:id/:requestId', component: OtpDocComponent },
  { path: 'approveRequest/:id', component: ApproveRequestComponent },
  { path: 'CancelRequest/:id', component: CancelRequestComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' }), ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
